// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MultiLineField__content-c3c8a0 {
  height: 100%;
}

.MultiLineField__content-c3c8a0.MultiLineField__dynamic-height-f8de18 {
  height: auto;
}

.MultiLineField__textarea-e8a94a {
  --scrollbar-bg-color: transparent;
  resize: none;
  cursor: auto;
}

.MultiLineField__dynamic-height-f8de18 .MultiLineField__textarea-e8a94a {
  flex: none;
  min-height: 28px;
  box-sizing: border-box;
}

.MultiLineField__input-wrapper-b3be14 {
  height: 100%;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/MultiLineField/MultiLineField.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,iCAAA;EAEA,YAAA;EACA,YAAA;AAAF;;AAGA;EACE,UAAA;EACA,gBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,YAAA;EACA,sBAAA;AAAF","sourcesContent":[".content {\n  height: 100%;\n}\n\n.content.dynamic-height {\n  height: auto;\n}\n\n.textarea {\n  --scrollbar-bg-color: transparent;\n\n  resize: none;\n  cursor: auto;\n}\n\n.dynamic-height .textarea {\n  flex: none;\n  min-height: 28px;\n  box-sizing: border-box;\n}\n\n.input-wrapper {\n  height: 100%;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `MultiLineField__content-c3c8a0`,
	"dynamic-height": `MultiLineField__dynamic-height-f8de18`,
	"dynamicHeight": `MultiLineField__dynamic-height-f8de18`,
	"textarea": `MultiLineField__textarea-e8a94a`,
	"input-wrapper": `MultiLineField__input-wrapper-b3be14`,
	"inputWrapper": `MultiLineField__input-wrapper-b3be14`
};
module.exports = ___CSS_LOADER_EXPORT___;
